<template>
	<div class="pb-2">
		<div class="head-title d-print-none" :class="$vuetify.breakpoint.xs ? 'px-1':'px-6'">
			<FinanceButtonMulti 
				:control="control"
				:itemNumberPost="itemNumberPost"
				:itemNumberMoreInfo="itemNumberMoreInfo"
				:itemNumberForward="itemNumberForward"
				:itemNumberPrint="itemNumberPrint"
				:itemNumberDelete="itemNumberDelete"
				:itemNumberRecover="itemNumberRecover"
				:postLoading="post_loading"
				:rejectLoading="visible_moreinfo"
				:forwardLoading="visible_forward"
				:deleteLoading="visible_delete"
				:printLoading="print_visible"
				:recoverLoading="visible_recover"
				@post-gl="onPostGL()"
				@more-info="onMoreInfoDialog()"
				@forward="onForwardDialog()"
				@print="onPrint()"
				@delete="onDeleteDialog()"
				@recover="onRecoverDialog()"
			/>
			<FinanceView
				:typeSelected="type"
				:viewSelected="view"
				:customiseView="customise_view"
				:statuses="finance_statuses"
				@status="onChangeStatus($event)"
				@column="onChangeColumn($event)"
			/>
		</div>
		<v-alert class="mx-5 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<ProgressGetDataLinear v-if="loading" class="px-5"/>
		<FinanceTable 
			class="ma-6" 
			v-if="!loading" 
			:header="select_column"
			:items="filterResults" 
			:color="color"
			:currencies="currencies"
			:titleText="$vuetify.breakpoint.xs ? 'Claims':'Claims for Finance Approval'"
			@row-item="onRowClick($event)"
			@button-visible="onButtonVisible($event)"
		/>
		<ApprovalDialog 
			v-if="visible_moreinfo"
			key="moreinfo"
			:visible="visible_moreinfo" 
			:color="color"
			:title_text="`More information required`"
			:suppliers="select_claims.map(c => { return c.supplier })"
			@cancel="onCancel()"
			@ok="onMoreInfo($event)"
		/>
		<ApprovalDialog 
			v-if="visible_forward"
			key="forward"
			:visible="visible_forward" 
			:color="color"
			:title_text="`Forward claim to...`"
			:isFinance="true"
			:userID="user_abid"
			:confirm_button="`Submit`"
			@cancel="onCancel()"
			@submit="onForward($event)"
		/>
		<DeleteConfirmDialog
			v-if="visible_delete"
			:visible="visible_delete"
			:title="`You are about to delete claim(s)`"
			:content="`This action cannot be undone. Are you sure?`"
			:okText="`Delete`"
			@cancel="visible_delete = false"
			@ok="onDelete()"
		/>
		<RecoverDialog
			v-if="visible_recover"
			:visible="visible_recover"
			:textColor="color"
			:titleText="'Recover deleted claim?'"
			:userName="pre_update_claims.length === 1 ? (pre_update_claims.map(c => { return c.supplier.display_name })).join(',') : ''"
			@cancel="visible_recover = false"
			@ok="onRecover($event)"
		/>
		<DialogNotice
			v-if="visible_notice" 
			:visible="visible_notice" 
			:text="notice_text"
		/>
		<DialogProgress 
			:visible="print_dialog" 
			:color="color"
		/>
		<PrintClaims 
			v-if="print_visible" 
			id="print"
			style="display: none"
			:printClaims="print_claims" 
		/>
	</div>
</template>
<script>
import ProgressGetDataLinear from "@/components/progress/progress_getdata_linear.vue";
import FinanceButtonMulti from "@/views/expenses/finance/finance_button_multi.vue";
import FinanceView from "@/views/expenses/finance/finance_view.vue";
import FinanceTable from "@/views/expenses/finance/finance_table.vue";
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import DialogProgress from "@/components/dialogs/progress_dialog.vue";
import ApprovalDialog from "@/views/expenses/approvals/approval_dialog.vue";
import PrintClaims from '@/components/expenses/print_claims';
import DeleteConfirmDialog from "@/views/expenses/commond/delete_confirm_dialog.vue";
import RecoverDialog from "@/views/expenses/commond/recover_dialog.vue";

import config from "@/config.js";
import moment from 'moment';

import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf';
import pdfjsworker from 'pdfjs-dist/es5/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsworker;

const SCALE = 1.2;
const MAX_WIDTH = 600;
const PAGE_INIT = 0;

const CLAIM_STATUSES = config.claim_statuses;

const ACCEPTED_SWITCH = {
	key: 'Approved',
	value: 'Submitted'
};
const FINANCE_STATUS = [
	{ text: 'Draft', value: 0 },
	{ text: 'Submitted', value: '1,2' },
	{ text: 'Rejected', value: 3 },
	{ text: 'Posted', value: 4 },
	{ text: 'Partially Paid', value: 7 },
	{ text: 'Paid', value: 6 },
	{ text: 'Deleted', value: 5 },
];
const FINANCE_STATUS_FULL = [
	{ text: 'Draft', value: 0 },
	{ text: 'Submitted', value: 1 },
	{ text: 'Approved', value: 2 },
	{ text: 'Rejected', value: 3 },
	{ text: 'Posted', value: 4 },
	{ text: 'Partially Paid', value: 7 },
	{ text: 'Paid', value: 6 },
	{ text: 'Deleted', value: 5 },
];

export default {
	name: 'ListFinance',
	props: {
		color: {
			type: String,
			default: ""
		},
		currencies: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			user_id: 0,
			error_msg: '',
			loading: false,
			control: false,
			select_column: config.finance_head,
			customise_view: config.finance_head.filter(head => {return head.showable && head.value !== 'select'}),
			webclaim_postseperately: true,
			finance_statuses: [],
			finance_list: [],
			finance_list_original: [],

			type: [],
			type_save: [],
			view: [],
			view_save: [],

			select_claims: [],
			pre_update_claims: [],
			all_completed: [],
			notice_text: [],
			tid: null,
			print_claims: [],
			image_arr: [],
			image_res_arr: [],
			print_dialog: false,
			print_visible: false,

			itemNumberPost: 0,
			itemNumberMoreInfo: 0,
			itemNumberForward: 0,
			itemNumberPrint: 0,
			itemNumberDelete: 0,
			itemNumberRecover: 0,

			visible_notice: false,
			visible_moreinfo: false,
			visible_forward: false,
			visible_progress: false,
			visible_delete: false,
			visible_recover: false,

			post_loading: false
		}
	},
	components: {
		ProgressGetDataLinear,
		FinanceButtonMulti,
		FinanceView,
		FinanceTable,
		DialogNotice,
		ApprovalDialog,
		DialogProgress,
		PrintClaims,
		DeleteConfirmDialog,
		RecoverDialog
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
	},
	async created() {
		await this.load_postseperately();

		if (!this.$store.state.user) {
			await this.getUserId();
		} else {
			this.user_id = this.$store.state.user.id;
		}

		await this.getSettings();
		this.init(this.type_save.map(status => { return status.value }));
	},
	computed: {
		user_abid() {
			const user = this.$store.state.user;
			if (user && user.addressbook) {
				return user.addressbook.id
			} else {
				return 0;
			}
		},
		user_abid_name() {
			let name = '';
			const user = this.$store.state.user;
			if (user) {
				name = user.addressbook.display_name;
			}
			return name;
		},
		filterResults() {
			const filterRes = [];
			this.finance_list.forEach(finance => {
				const obj = {};	
				const select_column_tmp = config.finance_head;

				select_column_tmp.forEach(item => {
					if (item.showable) {
						obj[item.value] = finance[item.value];
					}
				});

				obj['id']	= finance.id;
				obj['select'] = finance.select ? finance.select : false;

				filterRes.push(obj);
			});
			return filterRes;
		},
	},
	methods: {
		async load_postseperately() {
			const url = "/api/expenses/claims/meta";
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.webclaim_postseperately = data.webclaim_postseperately === 0 ? false: true;
						this.finance_statuses = this.webclaim_postseperately ? FINANCE_STATUS_FULL : FINANCE_STATUS;
						this.type = this.finance_statuses.filter(status => {
							if (this.webclaim_postseperately) {
								return status.value === CLAIM_STATUSES.pending.value || status.value === CLAIM_STATUSES.approved.value;
							} else {
								return status.value === '1,2';
							}
						});
						this.type_save = this.type;
					} else {
						console.log('error-reason:', reason);
					}
				})
				.catch(e => {
					console.log('e.message:', e.message);
				});
		},
		async getUserId() {
			const url = '/api/user/me';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.user_id = data.id;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getSettings() {
			this.loading = true;
			const usid = this.user_id;
			const winname_tmp = this.$route.name;
			const winname = config.win_name[`${winname_tmp}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const current_settings = data.filter(d => { return d.user_id === usid });
							const settings_winname = current_settings[0].window_name;
							const settings_windata_json = current_settings[0].windata_json;
							if (settings_winname === winname) {
								const windata = JSON.parse(settings_windata_json);
								const type_tmp = windata.type;
								const view_tmp = windata.options;

								this.type = this.finance_statuses.filter(c => { return type_tmp.includes(c.value) });
								this.view = config.finance_head.filter(head => {return head.showable && view_tmp.includes(head.value) });

								this.type_save = this.type;
								this.view_save = this.view;
							}
						} else {
							this.view = config.finance_head.filter(head => {return head.showable && head.value !== 'select'});
							this.view_save = config.finance_head.filter(head => {return head.showable && head.value !== 'select'});
						}

						this.initTableHead();

						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		updateSettings(win_setup) {
			const usid = this.user_id;
			const winname_tmp = this.$route.name;
			const winname = config.win_name[`${winname_tmp}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			const params_obj = {};
			params_obj['value'] = win_setup;

			return new Promise((resolve, reject) => {
				axios
					.post(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});			
		},
		initTableHead() {
			const head_seleced = config.finance_head.filter(head => { return head.showable && head.value === 'select'});
			
			const view = this.view.map(v => { return v.value });
			const head_other = config.finance_head.filter(head => { return view.includes(head.value) });

			this.select_column = [...head_seleced, ...head_other];
		},
		init(statusses) {
			this.loading = true;
			const params = [];

			if (statusses.length > 0) {
				const statusses_convert = [];
				statusses.forEach(s => {
					if (s === CLAIM_STATUSES.paid.value || s === CLAIM_STATUSES.partiallyPaid.value) {
						statusses_convert.push(CLAIM_STATUSES.posted.value);
					} else if (s === CLAIM_STATUSES.deleted.value) {
						statusses_convert.push(CLAIM_STATUSES.posted.value);
						statusses_convert.push(CLAIM_STATUSES.deleted.value);
						params.push("ignore_reversed=" + false);
					} else {
						statusses_convert.push(s);
					}
				});

				const statusses_set = new Set(statusses_convert);				
				params.push("statusses=" + [...statusses_set]);
			}

			let url = "/api/expenses/claims";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;
					if (status === 'OK') {
						if (!this.webclaim_postseperately) {
							data.forEach(d => {
								if (d.status === ACCEPTED_SWITCH.key) {
									d.status = ACCEPTED_SWITCH.value;
								}
							});
						}

						data.forEach(d => {
							if (d.status === CLAIM_STATUSES.posted.text && d.has_payment) {
								d.status = CLAIM_STATUSES.partiallyPaid.text;
							}

							if (d.status === CLAIM_STATUSES.reversal.text || d.status === CLAIM_STATUSES.reversed.text) {
								d.status = CLAIM_STATUSES.deleted.text;
							}
						});
						
						const statusses_selected = this.finance_statuses.filter(f => { return statusses.includes(f.value) });
						const statusses_selected_text = statusses_selected.map(s => { return s.text });
						const data_filter = data.filter(d => { return statusses_selected_text.includes(d.status) });

						const posted_arr = data_filter.filter(d => {return d.status === CLAIM_STATUSES.posted.text});
						posted_arr.sort((a, b) => {
							const date1 = Date.parse(a.submitted_date);
							const date2 = Date.parse(b.submitted_date);
							return date1 - date2;
						});

						const partially_arr = data_filter.filter(d => {return d.status === CLAIM_STATUSES.partiallyPaid.text});
						partially_arr.sort((a, b) => {
							const date1 = Date.parse(a.submitted_date);
							const date2 = Date.parse(b.submitted_date);
							return date1 - date2;
						});

						const paid_arr = data_filter.filter(d => {return d.status === CLAIM_STATUSES.paid.text});
						paid_arr.sort((a, b) => {
							const date1 = Date.parse(a.submitted_date);
							const date2 = Date.parse(b.submitted_date);
							return date1 - date2;
						});

						const delete_arr = data_filter.filter(d => {return d.status === CLAIM_STATUSES.deleted.text});
						delete_arr.sort((a, b) => {
							const date1 = Date.parse(a.submitted_date);
							const date2 = Date.parse(b.submitted_date);
							return date1 - date2;
						});

						const other_arr = data_filter.filter(d => {return d.status !== CLAIM_STATUSES.posted.text && d.status !== CLAIM_STATUSES.paid.text && d.status !== CLAIM_STATUSES.deleted.text && d.status !== CLAIM_STATUSES.partiallyPaid.text});
						other_arr.sort((a, b) => {
							const date1 = Date.parse(a.submitted_date);
							const date2 = Date.parse(b.submitted_date);
							return date1 - date2;
						});

						this.finance_list = [];
						this.finance_list.push(...other_arr);
						this.finance_list.push(...posted_arr);
						this.finance_list.push(...partially_arr);
						this.finance_list.push(...paid_arr);
						this.finance_list.push(...delete_arr);
						this.finance_list_original = this.finance_list;					

						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch(msg => {
					this.error_msg = msg;
					this.loading = false;
				});
		},
		onChangeStatus(status) {
			const status_arr = status.map(s => { return s.value });
			if (status_arr.length === 0) {
				this.finance_list = [];
				this.finance_list_original = this.finance_list;	
			} else {
				this.init(status_arr);
			}			

			this.type = status;
			this.type_save = status;
			const win_setup_str = this._setWinSetup();

			this.updateSettings(win_setup_str)
				.then(() => {
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
		},
		onChangeColumn(column) {
			const head_seleced = config.finance_head.filter(head => { return head.showable && head.value === 'select'});
			const head_other = config.approval_head.filter(head => { return column.includes(head.value) });
			this.select_column = [...head_seleced, ...head_other];

			this.view = config.finance_head.filter(head => {return head.showable && column.includes(head.value) });
			this.view_save = this.view;

			const win_setup_str = this._setWinSetup();

			this.updateSettings(win_setup_str)
				.then(() => {
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
		},
		onRowClick(item) {
			this.$emit('row-click', item);
		},
		onButtonVisible(claim_arr) {
			const arr_tmp = claim_arr.map(val => { return val.select});
			this.control = arr_tmp.some(val => {return val});

			const itemNumberPost_tmp = claim_arr.filter(val => { return val.select && val.status !== CLAIM_STATUSES.posted.text && val.status !== CLAIM_STATUSES.partiallyPaid.text && val.status !== CLAIM_STATUSES.paid.text && val.status !== CLAIM_STATUSES.deleted.text });
			this.itemNumberPost = itemNumberPost_tmp.length;

			const itemNumberMoreInfo_tmp = claim_arr.filter(val => { return val.select && val.status !== CLAIM_STATUSES.posted.text && val.status !== CLAIM_STATUSES.partiallyPaid.text && val.status !== CLAIM_STATUSES.paid.text && val.status !== CLAIM_STATUSES.deleted.text });
			this.itemNumberMoreInfo = itemNumberMoreInfo_tmp.length;

			const itemNumberForward_tmp = claim_arr.filter(val => { return val.select && val.status !== CLAIM_STATUSES.posted.text && val.status !== CLAIM_STATUSES.partiallyPaid.text && val.status !== CLAIM_STATUSES.paid.text && val.status !== CLAIM_STATUSES.deleted.text });
			this.itemNumberForward = itemNumberForward_tmp.length;

			const itemNumberPrint_tmp = claim_arr.filter(val => { return val.select });
			this.itemNumberPrint = itemNumberPrint_tmp.length;

			const itemNumberDelete_tmp = claim_arr.filter(val => { return val.select && val.status !== CLAIM_STATUSES.posted.text && val.status !== CLAIM_STATUSES.partiallyPaid.text && val.status !== CLAIM_STATUSES.paid.text && val.status !== CLAIM_STATUSES.deleted.text });
			this.itemNumberDelete = itemNumberDelete_tmp.length;

			const itemNumberRecover_tmp = claim_arr.filter(val => {
				return val.select && val.status === CLAIM_STATUSES.deleted.text && !val.number.includes('-r') && !val.number.includes('*r') && val.status !== CLAIM_STATUSES.posted.text && val.status !== CLAIM_STATUSES.partiallyPaid.text && val.status !== CLAIM_STATUSES.paid.text;
			});
			this.itemNumberRecover = itemNumberRecover_tmp.length;
		},
		async onPostGL() {
			if (this.post_loading) return;

			this.post_loading = true;

			const select_claims = this.filterResults.filter(res => { return res.select === true });

			// for right status claims
			const update_claims = select_claims.filter(c => { return c.status !== CLAIM_STATUSES.posted.text && c.status !== CLAIM_STATUSES.partiallyPaid.text && c.status !== CLAIM_STATUSES.paid.text && c.status !== CLAIM_STATUSES.deleted.text });

			for (let index = 0; index < update_claims.length; index++) {
				const element = update_claims[index];

				await this._post_gl(element.id);
			}

			// for results
			if (this.all_completed.length === update_claims.length && update_claims.length !== 0) {

				if (update_claims.length === 1) {
					this.notice_text.push('Claim successfully posted to the General Ledger.');
				} 
				if(update_claims.length > 1) {
					this.notice_text.push(`${update_claims.length} claims successfully posted to the General Ledger.`);
				}

				this.visible_notice = true;
				this.tid = setTimeout(this._close, 2000);

				this.onCancel();

				this.init(this.type_save.map(status => { return status.value }));
			} else {
				this.onCancel();
			}
		},
		async onMoreInfoDialog() {
			if (this.visible_moreinfo) return;

			this.select_claims = this.filterResults.filter(res => { return res.select === true });
			const update_claims = this.select_claims.filter(c => { return c.status !== CLAIM_STATUSES.posted.text && c.status !== CLAIM_STATUSES.partiallyPaid.text && c.status !== CLAIM_STATUSES.paid.text && c.status !== CLAIM_STATUSES.deleted.text });
			for (let index = 0; index < update_claims.length; index++) {
				const element = update_claims[index];
				await this._laod_claim(element.id);	
			}
			this.visible_moreinfo = true;
		},
		async onMoreInfo(reason) {
			const reason_with_date = `${reason}${config.remark_date_flag}${moment().format('YYYY-MM-DD')}`;

			const array = this.pre_update_claims;
			for (let index = 0; index < array.length; index++) {
				const element = array[index];

				const details = [];
				element.details.forEach(detail => {
					details.push({
						receipt_id: detail.receipt.id,
						amount: Number(Number(detail.amount).toFixed(2)),
						description: detail.description,
						phase_id: detail.phase.id,
						job_id: detail.job.id,
						kind_id: detail.kind.id,
						gross: Number(Number(detail.gross).toFixed(2)),
						tax_mode: detail.tax_mode,
						tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
						tax_amount: Number(Number(detail.tax_amount).toFixed(2)),
						markup: Number(Number(detail.markup).toFixed(2)),
						value_fc: Number(Number(detail.value_fc).toFixed(2)),
					});
				});

				const update_obj = {
					supplier_id: element.supplier.id,
					date: element.date,
					desc: element.description,
					currency_id: element.currency.id,
					approval_by: element.approval_by ? element.approval_by.id : null,
					status: CLAIM_STATUSES.rejected.value,
					remark: reason_with_date,
					period_id: element.period.id,
					details: details
				};
				await this._update_claim(element.id, update_obj);
			}
			
			this.onCancel();
			this.init(this.type_save.map(status => { return status.value }));
		},
		async onForwardDialog() {
			if (this.visible_forward) return;

			this.select_claims = this.filterResults.filter(res => { return res.select === true });
			const update_claims = this.select_claims.filter(c => { return c.status !== CLAIM_STATUSES.posted.text && c.status !== CLAIM_STATUSES.partiallyPaid.text && c.status !== CLAIM_STATUSES.paid.text && c.status !== CLAIM_STATUSES.deleted.text });
			for (let index = 0; index < update_claims.length; index++) {
				const element = update_claims[index];
				await this._laod_claim(element.id, true);	
			}
			this.visible_forward = true;
		},
		async onForward(event) {
			const array = this.pre_update_claims;
			for (let index = 0; index < array.length; index++) {
				const element = array[index];

				const details = [];
				element.details.forEach(detail => {
					details.push({
						receipt_id: detail.receipt.id,
						amount: Number(Number(detail.amount).toFixed(2)),
						description: detail.description,
						phase_id: detail.phase.id,
						job_id: detail.job.id,
						kind_id: detail.kind.id,
						gross: Number(Number(detail.gross).toFixed(2)),
						tax_mode: detail.tax_mode,
						tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
						tax_amount: Number(Number(detail.tax_amount).toFixed(2)),
						markup: Number(Number(detail.markup).toFixed(2)),
						value_fc: Number(Number(detail.value_fc).toFixed(2)),
					})
				});

				const update_obj = {
					supplier_id: element.supplier.id,
					date: element.date,
					desc: element.description,
					currency_id: element.currency.id,
					approval_by: event.approval_by ? event.approval_by.id : null,
					status: element.status,
					remark: event.reason,
					period_id: element.period.id,
					send_email: true,
					details: details
				};
				await this._update_claim(element.id, update_obj);
			}
			
			this.onCancel();
			this.init(this.type_save.map(status => { return status.value }));
		},
		async onPrint() {
			if (this.print_visible) return;

			this.print_dialog = true;
			this.print_visible = true;
			this.print_claims = [];

			const image_blob_arr = [];
			const selected_claims = this.filterResults.filter(f => { return f.select === true });

			for (let index = 0; index < selected_claims.length; index++) {
				const selected_claim = selected_claims[index];
				const url = "/api/expenses/claims/" + selected_claim.id;
				await axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then(val => {
						const { status, data, reason } = val.data;

						if (status == "OK") {
							data.details.forEach(d => {
								if (d.receipt.image_type.length !== 0) {
									const obj_tmp = {
										id: data.id,
										receipt: d.receipt 
									};
									image_blob_arr.push(obj_tmp);
								}
							});

							const obj = {
								id: selected_claim.id,
								number: selected_claim.number,
								desc: selected_claim.desc,
								submitted_date: selected_claim.submitted_date,
								value: selected_claim.value,
								currency: selected_claim.currency.symbol,
								approval_by: selected_claim.approval_by ? selected_claim.approval_by.display_name : '',
								employee: data.supplier.display_name,
								supplier: data.supplier.display_name,
								claim_date: selected_claim.date,
								details: data.details,
							};
							this.print_claims.push(obj);

						} else {
							this.error_msg = reason;
						}
					})
					.catch(e => {
						this.error_msg = e.message;
					});
			}

			this.getImageList(image_blob_arr);		
		},
		onDeleteDialog() {
			if (this.visible_delete) return;

			this.select_claims = this.filterResults.filter(res => { return res.select === true });
			const delete_claims = this.select_claims.filter(c => {
				return c.status !== CLAIM_STATUSES.posted.text && c.status !== CLAIM_STATUSES.partiallyPaid.text && c.status !== CLAIM_STATUSES.paid.text && c.status !== CLAIM_STATUSES.deleted.text;
			});
			this.pre_update_claims = delete_claims;
			this.visible_delete = true;
		},
		async onDelete() {
			const array = this.pre_update_claims;
			for (let index = 0; index < array.length; index++) {
				const element = array[index];
				await this._delete_claim(element.id);
			}

			this.onCancel();
			this.init(this.type_save.map(status => { return status.value }));
		},
		onRecoverDialog() {
			if (this.visible_recover) return;

			this.select_claims = this.filterResults.filter(res => { return res.select === true });

			const recover_claims = this.select_claims.filter(c => {
				return c.status === CLAIM_STATUSES.deleted.text && c.status !== CLAIM_STATUSES.posted.text && c.status !== CLAIM_STATUSES.partiallyPaid.text && c.status !== CLAIM_STATUSES.paid.text;
			});

			this.pre_update_claims = recover_claims;
			this.visible_recover = true;
		},
		async onRecover(reason) {
			const array = this.pre_update_claims;
			for (let index = 0; index < array.length; index++) {
				const element = array[index];
				await this._recover_claim(element.id, reason);
			}
			
			this.onCancel();
			this.init(this.type_save.map(status => { return status.value }));
		},
		async getImageList(image_blob_arr) {
			if (image_blob_arr.length === 0) {
				this.print_claims.forEach(print_claim => {
					print_claim['image_arr'] = [];
				});
				this.setPrintItem();
			}

			if (image_blob_arr.length !== 0) {
				for (let index = 0; index < image_blob_arr.length; index++) {
					const image_obj = image_blob_arr[index];
					const url = `/api/expenses/receipts/${image_obj.receipt.id}/image`;
					await axios
						.get(url, {
							headers: {
								"Authorization": "Bearer " + this.$store.state.token,
								"Accept": "application/json"
							},
							responseType: 'blob',
						})
						.then((val) => {
							const { status, data } = val;
							if (status === 200) {
								if (image_obj.receipt.image_type === 'application/pdf') {
									const reader = new FileReader();
									reader.readAsDataURL(data); 
									reader.onload = readerEvent =>  {
										const loadingTask = pdfjsLib.getDocument(readerEvent.target.result);
										loadingTask.promise.then(pdf => {
											const preview_url = [];
											let page_total = pdf.numPages;

											for (let index = 0; index < pdf.numPages; index++) {
												pdf.getPage(index + 1).then(page => {
													const scale = SCALE;
													const viewport = page.getViewport({scale: scale});

													const canvas = document.createElement('canvas');
													const context = canvas.getContext('2d');
													canvas.width = viewport.width;
													canvas.height = viewport.height;

													const renderContext = {
														canvasContext: context,
														viewport: viewport
													};

													const renderTask = page.render(renderContext);
													renderTask.promise.then(() => {
														canvas.toBlob(blob => {
															const preview_item_url = URL.createObjectURL(blob);
															preview_url.push(preview_item_url);
															page_total -= 1;

															if (page_total === PAGE_INIT) {
																const dimension = this.getDimension(viewport.width, viewport.height);
																const obj = {
																	id: image_obj.id,
																	width: dimension.width,
																	height: dimension.height,
																	image: preview_url
																};
																this.image_arr.push(obj);

																if (image_blob_arr.length === this.image_arr.length) {
																	this.print_claims.forEach(print_claim => {
																		print_claim['image_arr'] = this.image_arr;
																	});
																	this.setPrintItem();
																}
															}
														});									
													});
												});
											}
										});
									};
								} else {
									const my_image = new Image();
									const preview_item_url = URL.createObjectURL(data);
									my_image.src = preview_item_url;
									my_image.onload = () => {
										const dimension = this.getDimension(my_image.width, my_image.height);
										const obj = {
											id: image_obj.id,
											width: dimension.width,
											height: dimension.height,
											image: preview_item_url
										};
										this.image_arr.push(obj);

										if (image_blob_arr.length === this.image_arr.length) {
											this.print_claims.forEach(print_claim => {
												print_claim['image_arr'] = this.image_arr;
											});
											this.setPrintItem();
										}
									}

								}
							}
						})
						.catch((e) => {
							this.$emit('error-msg', e.message);
						});
				}
			}
		},
		getDimension(width, height) {
			let image_width = 0;
			let image_height = 0;

			if (this.$vuetify.breakpoint.smAndDown) {
				/* 48 = padding-left-24px + padding-right-24px */
				if (width > height) {
					image_width = this.$vuetify.breakpoint.width - 48;
					image_height = (this.$vuetify.breakpoint.width - 48) * height / width;
				} else {
					image_height = this.$vuetify.breakpoint.width - 48;
					image_width = (this.$vuetify.breakpoint.width - 48) * width / height;
				}
			} else {
				if (width > height) {
					image_width = MAX_WIDTH;
					image_height = MAX_WIDTH * height / width;
				} else {
					image_height = MAX_WIDTH;
					image_width = MAX_WIDTH * width / height;
				}
			}

			return { width: image_width, height: image_height };
		},
		setPrintItem() {
			this.print_dialog = false;
			this.print_visible = true;

			setTimeout(() => { 
				const printHtml = document.getElementById("print").innerHTML;
				const printFrame = document.createElement('iframe');
				printFrame.srcdoc = printHtml;
				document.body.appendChild(printFrame);

				printFrame.onload = () => {
					printFrame.contentWindow.print();
					
					const mql = printFrame.contentWindow.matchMedia('print');
					mql.onchange = (e) => {
						if (e.matches) {
							/* before print */
						} else {
							/* after print */
							document.body.removeChild(printFrame);
							this.print_visible = false;
							this.image_arr = [];
							this.init(this.type_save.map(status => { return status.value }));
						}
					}
				}
			},20);
		},
		onCancel() {
			this.post_loading = false;
			this.visible_forward = false;
			this.visible_moreinfo = false;
			this.visible_delete = false;
			this.visible_recover = false;
			this.select_claims = [];
			this.pre_update_claims = [];
			this.all_completed = [];
		},
		_isLateStatus(submitted_date, period) {
			/* if submitted_date is 2021-08-30. before start-date(2021-09-01), it will be 'Late'. */
			/* f submitted_date is 2021-10-01. after end-date(2021-09-30), it will be 'Pending'. */

			const submitted = moment(submitted_date).format('YYYYMMDD');
			const period_start = moment(period.start_date).format('YYYYMMDD');
			const stage1 = submitted < period_start;

			const today = moment(new Date()).format('YYYYMMDD');
			const period_end = moment(period.end_date).format('YYYYMMDD');
			const stage2 = today > period_end;
			
			return stage1 || stage2;
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];
		},
		_add(num1, num2) {
			const num1Digits = (num1.split('.')[1] || '').length;
			const num2Digits = (num2.split('.')[1] || '').length;
			const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
			const result = (num1 * baseNum + num2 * baseNum) / baseNum;
			return result.toString();
		},
		async _laod_claim(id) {
			const url = "/api/expenses/claims/" + id;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " +this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.pre_update_claims.push(data);
						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		async _update_claim(id, update_obj) {
			const url = "/api/expenses/claims/" + id;
			await axios
				.put(url, update_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.all_completed.push(true);
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		async _post_gl(id) {
			const url = `/api/supplier_invoice/${id}/transaction`;
			await axios
				.post(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.all_completed.push(true);
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				});
		},
		async _delete_claim(id) {
			const url = `/api/expenses/claims/${id}`;
			await axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.pre_update_claims = this.pre_update_claims.filter(p => { return p.id !== id });

						if (this.pre_update_claims.length === 0) {
							this.notice_text.push(`Claim(s) were successfully deleted.`);
							this.visible_notice = true;
							this.tid = setTimeout(this._close, 2000);
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		async _recover_claim(id, reason) {
			const url = `/api/expenses/claims/${id}/reactivate?remark=${reason}`;

			await axios
				.post(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.pre_update_claims = this.pre_update_claims.filter(p => { return p.id !== id });

						if (this.pre_update_claims.length === 0) {
							this.notice_text.push(`Claim(s) were successfully recovered.`);
							this.visible_notice = true;
							this.tid = setTimeout(this._close, 2000);
						}
						
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		_setWinSetup() {
			const type_tmp = this.type_save.map(t => { return t.value });
			const view_tmp = this.view_save.map(t => { return t.value });

			const win_setup_obj = {
				type: type_tmp,
				options: view_tmp,
			};

			const win_setup_str = JSON.stringify(win_setup_obj);
			return win_setup_str;
		}
	}
}
</script>
<style lang="scss" scoped>
.head-title {
  height: 68px;
  display: flex;
  flex-flow: row nowrap;
	justify-content: space-between;
  align-items: center;
  background: #FFFFFF;
  box-shadow: inset 0px 3px 5px rgba(0, 0, 0, 0.1);
}
.head-title-xs {
	// height: 68px;
  display: flex;
  flex-flow: column nowrap;
	// justify-content: center;
  align-items: flex-start;
  background: #FFFFFF;
  // box-shadow: inset 0px 3px 5px rgba(0, 0, 0, 0.1);

}
.head-title-single {
  justify-content: flex-end;
}
.head-title-multi {
  justify-content: space-between;
}
</style>